module.exports = __webpack_public_path__ + "./assets/img_zhongshan_color__100fdf4ca5ef8a4a0cc3db6367e904e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_zhongshan_color.jpg
// module id = 647
// module chunks = 12